import React from 'react';
import s from './FadeIn.scss';
export const FadeIn = _ref => {
  let {
    children
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: s.root
  }, children);
};
//# sourceMappingURL=FadeIn.js.map